import { BaseRestRepository } from '~/repositories/baseRestRepository';
import { settingsServiceUrl } from '~/utils/env';

const SETTINGS_BASE_URL = `${settingsServiceUrl()}/company-portal/settings`;
const RENTAL_APPLICATION_GENERAL_SETTINGS_URL = `${SETTINGS_BASE_URL}/rentalapplicationgeneral`;
const RENTAL_APPLICATION_GENERAL_COMPANY_SETTINGS_URL = `${RENTAL_APPLICATION_GENERAL_SETTINGS_URL}/company`;

export class RentalApplicationGeneralSettingsRepository extends BaseRestRepository {
  public async getRentalApplicationGeneralSettings(): Promise<any> {
    const response = await this.fetchWithAuth(RENTAL_APPLICATION_GENERAL_COMPANY_SETTINGS_URL);
    return this.getJsonResponse(response);
  }

  public async deleteRentalApplicationGeneralSettings(): Promise<void> {
    return undefined;
  }

  public async updateRentalApplicationGeneralSettings(payload: any): Promise<any> {
    const response = await this.fetchWithAuth(RENTAL_APPLICATION_GENERAL_COMPANY_SETTINGS_URL, {
      method: 'POST',
      body: JSON.stringify({ settings: payload }),
    });
    return this.getJsonResponse(response);
  }
}
